import React, { useEffect, useState } from 'react';
import { AudioProvider } from './contexts/AudioContext';
import Hero from './components/Hero';
import Transportation from './components/Transportation';
import CoupleProfile from './components/CoupleProfile';
import EventDetail from './components/EventDetail';
import Countdown from './components/Countdown';
import LoveStory from './components/LoveStory';
import RSVP from './components/RSVP';
import Gift from './components/Gift';
import Footer from './components/Footer';
import Route from './components/Route';
import Hotels from './components/Hotels';

function App() {
  const [showRoute, setShowRoute] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setShowRoute(true);
      } else {
        setShowRoute(false);
      }
    };
// scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) === -1
    document.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  useEffect(() => {
    fetch('https://api.daniraquel.love/load').then(() => {
      console.log('Load api function succedded')
    }).catch(() => {
      console.log('Load api function error')
    })
  }, [])

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  }, [])

  return (
    <AudioProvider>
      <div className="relative">
        {showRoute && <Route />}

        <div className="overflow-hidden">
          <div id="Hero"><Hero /></div>
          <div id="Countdown"><Countdown /></div>
          <div id="Events"><EventDetail /></div>
          {/* <div id="Transportation"><Transportation /></div> */}
          <div id="Hotels"><Hotels /></div>
          <div id="RSVP"><RSVP /></div>
          <div id="Gift"><Gift /></div>
          <div id="Couple"><CoupleProfile /></div>
          <div id="Story"><LoveStory /></div>
          <Footer />
        </div>
      </div>
    </AudioProvider>
  );
}

export default App;